import React, { useState } from 'react';
import {
  Button,
  TextField,
  Container,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from "../context/AuthContext";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signUp } = useAuth();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setError(''); // Clear any existing errors
      await signUp(name, email, password);
      navigate('/');
    } catch (error) {
      if (error.message.includes('email-already-in-use')) {
        setError('This email is already registered');
      } else if (error.message.includes('invalid-email')) {
        setError('Please enter a valid email address');
      } else if (error.message.includes('weak-password')) {
        setError('Password must be at least 6 characters');
      } else {
        setError('Failed to create account. Please try again.');
      }
    }
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: '100vh',
        backgroundColor: '#0D47A1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '480px',
          backgroundColor: '#FFFFFF',
          borderRadius: 2,
          padding: 4,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* Error Alert */}
          {error && (
            <Alert
              severity="error"
              sx={{
                width: '100%',
                mb: 2,
                '& .MuiAlert-message': {
                  width: '100%',
                  textAlign: 'center'
                }
              }}
            >
              {error}
            </Alert>
          )}
          <Box
            component="img"
            src="/icon.png"
            sx={{ width: 48, height: 48, mb: 3 }}
          />
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              fontWeight: 600,
            }}
          >
            Create an account
          </Typography>
          <Typography
            sx={{
              color: 'text.secondary',
              mb: 4,
              textAlign: 'center'
            }}
          >
            Get <Box component="span" sx={{ color: '#0D47A1' }}>10x</Box> better response from recruiters and leads with{' '}
            <Link
              to="/"
              style={{
                textDecoration: 'underline',
                color: '#0D47A1',
                fontWeight: 600
              }}
              onMouseEnter={(e) => e.target.style.color = '#FF9138'}
              onMouseLeave={(e) => e.target.style.color = '#0D47A1'}
            >
              apply-bridge
            </Link>
            .
          </Typography>

          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              fullWidth
              label="Name"
              variant="outlined"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError(''); // Clear error on input change
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(''); // Clear error on input change
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              variant="outlined"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(''); // Clear error on input change
              }}
              sx={{ mb: 3 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                py: 1.5,
                textTransform: 'none',
                fontSize: '1rem'
              }}
            >
              Sign up
            </Button>
          </form>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Already have an account?{' '}
              <Typography
                component="span"
                sx={{
                  color: 'primary.main',
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
                onClick={() => navigate('/login')}
              >
                Sign in
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Register;